import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-left-up",
  "use": "icon-co-left-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-left-up\" id=\"icon-co-left-up\"><polyline points=\"14 9 9 4 4 9\" /><path d=\"M20 20h-7a4 4 0 0 1-4-4V4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol